import { gql } from 'apollo-boost'
import { UserFragment } from '../fragments'

export default gql`
  mutation ClaimBonusCodeReward {
    claimBonusCodeReward {
      currentUser {
        id
        ...User
      }
      errors {
        key
        message
      }
    }
  }
  ${UserFragment}
`
